export const global = {
  body: {
    color: 'text.900',
    fontSize: '1rem',
  },
  p: {
    a: {
      transition: '0.2s ease color',
      _hover: {
        color: 'brand.500',
      }
    }
  }
};
